import { Divider, Tabs } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import Cookies from "js-cookie";

import { AxiosCustomGet } from "../../../../../../components/axios/AxiosCustom";
import Config from "../../../../../../components/axios/Config";
import Breadcrumb from "../../../../../../components/common/Breadcrumb/Breadcrumb";
import Title from "../../../../../../components/common/Title/Title";
import HeaderInfo from "./HeaderInfo";
import SummaryTab from "./SummaryTab";
import InsuranceTab from "./InsuranceTab";
import ValuationTab from "./ValuationTab";
import PictureTab from "./PictureTab";
import CustomTable from "../../../../../../components/common/Table/CustomTable";
import PreviewImage from "../../../../../../components/common/PreviewImage/PreviewImage";

import { convertGadaiReportDetail } from "../../../helpers/convertGadaiReportDetail";

import { summaryTableColumn } from "./constants";

import "./styles.css";
import DetailDialog from "../../../../components/DetailDialog";
import { convertTransactionDetail } from "../../../../transaction_history/pawn_transaction/helpers";
import DetailCampaignDialog from "../../../../components/DetailCampaignDialog";
import ExtensionTab from "./ExtensionTab";
import InstallmentTab from "./InstallmentTab";

const TabPane = Tabs.TabPane;

const GadaiReportDetail = ({ match }) => {
  const gadaiID = match?.params?.id ?? "";
  const [tabState, setTabState] = useState("summary");
  const [gadaiDetailData, setGadaiDetailData] = useState("summary");
  const [imgLink, setImgLink] = useState("");
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState({});
  const [isDetailDialogOpen, setIsDetailDialogOpen] = useState(false);
  const [campaignDetailDialog, setCampaignDetailDialog] = useState(false);

  const breadCrumbItems = useMemo(() => {
    return [
      {
        text: "Daftar Gadai",
        link: "/report/pawn",
      },
    ];
  }, []);

  const getGadaiDetail = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}gadai/${gadaiID}/report`;

    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        // console.log('data', JSON.stringify(response.data.data))
        setGadaiDetailData(
          convertGadaiReportDetail(
            response.data.data,
            handleOpenPreview,
            handleOpenCampignDetail
          )
        );
      },
      (error) => {
        console.log('error getGadaiDetail', error);
      }
    )
  };

  const handleOpenPreview = (src) => () => {
    setImgLink(src);
    setIsPreviewOpen(true);
  };

  const handlePreview = (src) => {
    setImgLink(src);
    setIsPreviewOpen(true);
  };

  const handleTabChange = (key) => {
    setTabState(key);
  };

  useEffect(() => {
    getGadaiDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const copyToClipbord = (record) => {
    navigator.clipboard.writeText(record.midtransId);
  };

  const handleDetail = (record) => {
    getTransactionDetail(record.financeTrxId);
  };

  const handlePrintReceipt = () => {
    window.open(
      `/history/capital-cash/print-nota/${selectedTransaction.gadaiID}`,
      "_blank",
      "noopener"
    );
    setIsDetailDialogOpen(false);
  };

  const handleCloseDetail = () => {
    setSelectedTransaction({});
    setIsDetailDialogOpen(false);
  };

  const getTransactionDetail = (transactionID) => {
    const data = {
      transaction_id: transactionID,
    };
    let url = `${process.env.REACT_APP_BASE_API_URL}transaction-history/gadai/detail`;
    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        },
        data
      ),
      (response) => {
        const detail = convertTransactionDetail(response.data.data);
        setSelectedTransaction(detail);
        setIsDetailDialogOpen(true);
      },
      (error) => {
        console.log(error.response);
      }
    );
  };

  const handleCloseDetailCampaign = () => {
    setCampaignDetailDialog(false);
  };

  const handleOpenCampignDetail = () => {
    setCampaignDetailDialog(true);
  };
  return (
    <div>
      <div className="px-3">
        <div className="py-4 d-flex flex-column" style={{ fontSize: "13px" }}>
          <Title text={"Detail Gadai"} />
          <Breadcrumb
            breadCrumbItems={breadCrumbItems}
            current={"Detail Gadai"}
          />
        </div>

        <div className="detail-card-container">
          <div className="d-flex">
            <HeaderInfo
              gadaiID={gadaiID}
              data={{
                commonInfo: gadaiDetailData.commonInfo,
                headerInfo: gadaiDetailData.headerInfo,
              }}
            />
          </div>
          <Divider dashed className="detail-divider" />
          <Tabs
            defaultActiveKey="summary"
            style={{ fontSize: "13px" }}
            onChange={handleTabChange}
          >
            <TabPane tab="Rincian Pinjaman" key="summary">
              <SummaryTab
                data={{
                  commonInfo: gadaiDetailData.commonInfo,
                  summaryInfo: gadaiDetailData.summaryInfo,
                }}
              />
            </TabPane>
            {
              gadaiDetailData?.commonInfo?.paymentType === 'installment'
                ?
                <TabPane tab="Tagihan Cicilan" key="installment">
                  <InstallmentTab
                    data={gadaiDetailData.installment}
                  />
                </TabPane>
                :
                <TabPane tab="Rincian Perpanjangan" key="extension">
                  <ExtensionTab
                    data={{
                      extensions: gadaiDetailData.extensions,
                    }}
                  />
                </TabPane>
            }
            <TabPane tab="Barang Jaminan" key="insurance">
              <InsuranceTab
                data={{
                  commonInfo: gadaiDetailData.commonInfo,
                  insuranceInfo: gadaiDetailData.insuranceInfo,
                }}
              />
            </TabPane>
            <TabPane tab="Hasil Valuasi" key="valuation">
              <ValuationTab
                data={{
                  commonInfo: gadaiDetailData.commonInfo,
                  valuationInfo: gadaiDetailData.valuationInfo,
                }}
              />
            </TabPane>
            <TabPane tab="Foto" key="picture">
              <PictureTab
                data={gadaiDetailData.pictureInfo}
                handlePreview={(e) => handlePreview(e)}
              />
            </TabPane>
          </Tabs>
        </div>

        <div className="summary-table-container">
          <div className="detail-bold-text summary-table-title">
            Riwayat Transaksi
          </div>
          <CustomTable
            columns={summaryTableColumn(copyToClipbord, handleDetail)}
            data={gadaiDetailData.summaryTableInfo}
          />
        </div>
      </div>
      <PreviewImage
        visible={isPreviewOpen}
        setVisible={setIsPreviewOpen}
        url={imgLink}
      />
      <DetailDialog
        setVisible={setIsDetailDialogOpen}
        visible={isDetailDialogOpen}
        handlePrint={handlePrintReceipt}
        handleCancel={handleCloseDetail}
        data={selectedTransaction}
        type="pawn"
      />
      <DetailCampaignDialog
        visible={campaignDetailDialog}
        handleCancel={handleCloseDetailCampaign}
        data={gadaiDetailData}
      />
    </div>
  );
};

export default GadaiReportDetail;
